// eslint-disable-next-line import/no-extraneous-dependencies
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import useJwt from '@/auth/jwt/useJwt'
import { getValidPhoneSetupHandoff } from '@/auth/phoneSetupHandoff'
import { invalidateSubscriptionStanding } from '@/libs/subscriptionStanding'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/tour'
import VueSocialSharing from 'vue-social-sharing'

import VueKonva from 'vue-konva'
import App from './App.vue'
import store from './store'
import router from './router'

Vue.use(VueKonva, { prefix: 'Konva' })

if (typeof window !== 'undefined') {
  let pendingEntitlementRoute = null
  const pushEntitlementRouteOnce = name => {
    if (router.currentRoute.name === name || pendingEntitlementRoute === name) return
    pendingEntitlementRoute = name
    let navigation
    try {
      navigation = router.push({ name })
    } catch (error) {
      pendingEntitlementRoute = null
      return
    }
    Promise.resolve(navigation)
      .catch(() => {})
      .finally(() => {
        if (pendingEntitlementRoute === name) pendingEntitlementRoute = null
      })
  }

  window.addEventListener('diko:subscription-required', () => {
    pushEntitlementRouteOnce('financial-settings')
  })
  // Post-pending pipeline handoff §2: approval-standing failures (403012) go
  // to the application/credentials screen, never the purchase page.
  window.addEventListener('diko:approval-required', () => {
    pushEntitlementRouteOnce('account-settings')
  })

  // A successful callback makes the provider-derived subscription start
  // durable locally. A full redirect normally gives us a fresh JS context;
  // this hook also makes same-context/test navigation safe without deriving
  // any date from callback or browser time.
  router.afterEach(to => {
    if (to.name === 'after-payment' && to.query && to.query.status === 'success') {
      invalidateSubscriptionStanding()
    }
  })
}

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)
Vue.use(VueSocialSharing)
// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

const mountApp = async () => {
  const startsAtPhoneSetup = typeof window !== 'undefined'
    && /\/phone-setup\/?$/.test(window.location.pathname)
  if (!startsAtPhoneSetup || !getValidPhoneSetupHandoff()) {
    if (!startsAtPhoneSetup) await useJwt.bootstrap().catch(() => false)
  }

  new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
  }).$mount('#app')
}

mountApp()
